import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import * as serviceWorker from './serviceWorker';
import { combineReducers, createStore } from 'redux';
import { Provider } from 'react-redux';

import charactersReducer from './reducers/characters-reducer';
import colorsReducer from './reducers/colors-reducer';
import productsReducer from './reducers/products-reducer';
import sizesReducer from './reducers/sizes-reducer';

import activeCharacterReducer from './reducers/active-character-reducer';
import activeColorReducer from './reducers/active-color-reducer';
import activeProductReducer from './reducers/active-product-reducer';
import activeSizeReducer from './reducers/active-size-reducer';



const allReducers = combineReducers({
  characters: charactersReducer,
  colors: colorsReducer,
  products: productsReducer,
  sizes: sizesReducer,

  character: activeCharacterReducer,
  color: activeColorReducer,
  product: activeProductReducer,
  size: activeSizeReducer,
});

const store = createStore(
  allReducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

ReactDOM.render(<Provider store={store}><App />
  </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
